import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner, Alert } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";
import InvoicePrintFooter from "./InvoicePrintFooter";

const fmt4 = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const n = Number(String(v).replace(",", "."));
  return Number.isFinite(n) ? n.toFixed(4) : "";
};
const fmt2 = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const n = Number(String(v).replace(",", "."));
  return Number.isFinite(n) ? n.toFixed(2) : "";
};

export default function IesirePrint() {
  const { id } = useParams();
  const [busy, setBusy] = useState(true);
  const [err, setErr] = useState("");
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setBusy(true);
      setErr("");
      try {
        const d = await authFetch(`/iesire/${id}`);
        if (cancelled) return;
        setDoc(d);

        // print dupa ce renderul apuca sa se aseze
        setTimeout(() => window.print(), 250);
      } catch (e) {
        if (!cancelled) setErr(String(e?.message || e));
      } finally {
        if (!cancelled) setBusy(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (busy)
    return (
      <div className="p-3">
        <Spinner animation="border" />
      </div>
    );
  if (err)
    return (
      <div className="p-3">
        <Alert variant="danger">{err}</Alert>
      </div>
    );
  if (!doc) return null;

  const linii = doc.linii || [];
  const valuta = (doc.valuta_cod || "RON").toUpperCase();
  const valutaLabel = valuta === "EUR" ? "EURO" : valuta;

  return (
    <div className="print-a4 invoice-print" style={{ position: "relative", width: "210mm", minHeight: "297mm", margin: "20px auto", padding: "15mm 15mm 70mm 15mm", boxSizing: "border-box", backgroundColor: "white", boxShadow: "0 0 10px rgba(0,0,0,0.1)" }}>
      <style>{`
        @media print {
          @page { size: A4 portrait; margin: 0; }
          body:has(.invoice-print),
          #root:has(.invoice-print),
          .app-layout:has(.invoice-print) {
            margin: 0 !important;
            padding: 0 !important;
            min-height: 0 !important;
          }
          .app-layout:has(.invoice-print) > :not(.invoice-print) {
            display: none !important;
          }
          body {
            background: #fff !important;
            color: #000 !important;
          }
          .print-a4.invoice-print {
            width: 100% !important;
            margin: 0 !important;
            box-shadow: none !important;
            padding: 15mm 15mm 70mm 15mm !important;
            /* Leave a fraction of a millimetre for print unit rounding. */
            min-height: 276mm !important;
          }
          /* Keep report print rules from resizing invoice columns and footer. */
          .invoice-print table {
            table-layout: fixed !important;
            font-size: 11px !important;
          }
          .invoice-print th,
          .invoice-print td {
            min-width: 0 !important;
            max-width: none !important;
            white-space: normal !important;
            overflow-wrap: anywhere !important;
            word-wrap: break-word !important;
          }
          .invoice-print .print-table th,
          .invoice-print .print-table td {
            padding: 6px 3px !important;
          }
          .invoice-print .invoice-footer {
            left: 15mm !important;
            right: 15mm !important;
            break-inside: avoid;
          }
          .no-print {
            display: none !important;
          }
        }
        .print-a4 {
          font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
          color: #111;
          font-size: 11px;
          line-height: 1.4;
        }
        .header-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
        }
        .header-box {
          border: 1px solid #ccc;
          padding: 12px;
          border-radius: 4px;
          min-height: 180px;
        }
        .header-box-title {
          font-weight: bold;
          font-size: 12px;
          border-bottom: 1.5px solid #222;
          margin-bottom: 8px;
          padding-bottom: 2px;
          text-transform: uppercase;
        }
        .title-box {
          text-align: center;
          margin: 20px 0;
          padding: 10px;
          border-top: 2px solid #222;
          border-bottom: 2px solid #222;
        }
        .title-box h1 {
          font-size: 18px;
          margin: 0 0 4px 0;
          font-weight: bold;
          letter-spacing: 2px;
        }
        .print-table {
          width: 100%;
          border-collapse: collapse;
          margin: 20px 0;
        }
        .print-table th {
          background-color: #f7f7f7;
          border: 1px solid #444;
          padding: 6px 8px;
          font-weight: bold;
          font-size: 11px;
          text-transform: uppercase;
        }
        .print-table td {
          border: 1px solid #444;
          padding: 6px 8px;
          vertical-align: top;
        }
        .print-totals {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;
        }
        .totals-box {
          width: 250px;
          border: 1px solid #444;
          padding: 8px;
          border-radius: 4px;
        }
        .row2 {
          display: flex;
          justify-content: space-between;
          padding: 3px 0;
          font-size: 11px;
        }
        .grand {
          font-weight: bold;
          border-top: 1.5px solid #222;
          margin-top: 5px;
          padding-top: 5px;
          font-size: 12px;
        }
        .print-footer {
          margin-top: 60px;
          display: flex;
          justify-content: space-between;
        }
        .footer-sign {
          width: 200px;
          text-align: center;
        }
        .footer-sign .line {
          border-bottom: 1px solid #444;
          margin-top: 40px;
        }
      `}</style>

      {/* Antet Furnizor si Client */}
      <div className="header-container">
        {/* Furnizor (Stanga) */}
        <div className="header-box">
          <div className="header-box-title">Furnizor</div>
          <div><strong>{doc.firma_denumire || "SIMAUSROM"}</strong></div>
          <div>CIF: {doc.firma_cui || "-"}</div>
          <div>Reg. Com.: {doc.firma_regcom || "-"}</div>
          <div>Adresa: {doc.firma_adresa || "-"}</div>
          <div>Judet: {doc.firma_judet || "-"}</div>
          <div>Tara: {doc.firma_tara || "Romania"}</div>
          <div>Telefon: {doc.firma_tel || "-"}</div>
          {doc.firma_cap_social && <div>Cap. Social: {doc.firma_cap_social}</div>}
          <div>Banca: {doc.firma_banca1 || "-"}</div>
          <div>IBAN: {doc.firma_cont1 || "-"}</div>
          {doc.firma_cont2 && (
            <>
              <div>Banca 2: {doc.firma_banca2 || "-"}</div>
              <div>IBAN 2: {doc.firma_cont2 || "-"}</div>
            </>
          )}
        </div>

        {/* Client (Dreapta) */}
        <div className="header-box">
          <div className="header-box-title">Client</div>
          <div><strong>{doc.contact_name || doc.contact_label || "-"}</strong></div>
          <div>CIF/CUI: {doc.contact_cui || "-"}</div>
          <div>Reg. Com.: {doc.contact_regcom || "-"}</div>
          <div>Adresa: {doc.contact_adresa || "-"}</div>
          <div>Judet: {doc.contact_judet || "-"}</div>
          <div>Tara: {doc.contact_tara || "Romania"}</div>
          <div>Telefon: {doc.contact_tel || "-"}</div>
          <div>Banca: {doc.contact_banca || "-"}</div>
          <div>IBAN: {doc.contact_cont || "-"}</div>
        </div>
      </div>

      {/* Titlu document */}
      <div className="title-box">
        <h1>FACTURA</h1>
        <div>
          Seria / Numar: <b>{doc.doc_no || "-"}</b> &nbsp;|&nbsp; Data:{" "}
          <b>{String(doc.doc_date || "").slice(0, 10) || "-"}</b>
        </div>
      </div>

      {doc.observatii && (
        <div style={{ marginBottom: "10px", fontSize: "14px" }}>
          <b>{(doc.observatii.startsWith("Auto:") || doc.observatii.startsWith("Serie sasiu:")) ? "Detalii auto:" : "Observații:"}</b> {doc.observatii}
        </div>
      )}
      
      {/* Tabel linii */}
      <table className="print-table" style={{ tableLayout: "fixed", wordWrap: "break-word", width: "100%" }}>
        <colgroup>
          <col style={{ width: "4%" }} />
          <col style={{ width: "41%" }} />
          <col style={{ width: "8%" }} />
          <col style={{ width: "5%" }} />
          <col style={{ width: "14%" }} />
          <col style={{ width: "14%" }} />
          <col style={{ width: "14%" }} />
        </colgroup>
        <thead>
          <tr>
            <th>#</th>
            <th>Articol / Serviciu</th>
            <th className="text-end">Cant.</th>
            <th>UM</th>
            <th className="text-end">Pret</th>
            <th className="text-end">Valoare</th>
            <th className="text-end">TVA</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            const isServiceInvoice = linii.some(l => l.descriere && (l.descriere.startsWith('[M] ') || l.descriere.startsWith('[P] ')));

            const renderNormalLines = (linesArr, startIndex = 0) => {
                return linesArr.map((ln, idx) => {
                    let desc = ln.descriere || "";
                    let label = ln.bxpart_label || ln.part_label || ln.denumire || "-";
                    
                    if (desc.startsWith('[M] ') || desc.startsWith('[P] ')) {
                        desc = desc.substring(4);
                        if (desc.includes(' | ')) {
                            const parts = desc.split(' | ');
                            const cod = parts[0];
                            const denumire = parts.slice(1).join(' | ');
                            label = doc.service_print_part_codes === false ? denumire : `${denumire} (Cod: ${cod})`;
                            desc = "";
                        }
                    }
                    
                    return (
                      <tr key={ln.id || idx}>
                        <td>{startIndex + idx + 1}</td>
                        <td>
                          <div><b>{label}</b></div>
                          {desc && <div style={{ fontSize: "10px", color: "#555", marginTop: "2px" }}>{desc}</div>}
                        </td>
                        <td className="text-end">{fmt4(ln.qty)}</td>
                        <td>{ln.um || ln.um_label || ""}</td>
                        <td className="text-end">{fmt4(ln.price)}</td>
                        <td className="text-end">{fmt2(ln.suma_fara_tva)}</td>
                        <td className="text-end">{fmt2(ln.suma_tva)}</td>
                      </tr>
                    );
                });
            };

            if (!isServiceInvoice) {
                return renderNormalLines(linii, 0);
            }

            const manoperaLines = linii.filter(l => l.descriere && l.descriere.startsWith('[M] '));
            const pieseLines = linii.filter(l => l.descriere && l.descriere.startsWith('[P] '));
            const otherLines = linii.filter(l => !(l.descriere && (l.descriere.startsWith('[M] ') || l.descriere.startsWith('[P] '))));
            
            let totalManoperaFaraTva = 0;
            manoperaLines.forEach(l => totalManoperaFaraTva += (Number(l.suma_fara_tva) || 0));
            
            let totalPieseFaraTva = 0;
            pieseLines.forEach(l => totalPieseFaraTva += (Number(l.suma_fara_tva) || 0));
            
            return (
                <>
                  {manoperaLines.length > 0 && (
                      <>
                      <tr>
                          <td colSpan="7" style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}>MANOPERA</td>
                      </tr>
                      {renderNormalLines(manoperaLines, 0)}
                      <tr>
                          <td colSpan="5" className="text-end" style={{ fontWeight: "bold" }}>TOTAL MANOPERA:</td>
                          <td className="text-end" style={{ fontWeight: "bold" }}>{fmt2(totalManoperaFaraTva)}</td>
                          <td></td>
                      </tr>
                      </>
                  )}
                  
                  {pieseLines.length > 0 && (
                      <>
                      <tr>
                          <td colSpan="7" style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}>PIESE DE SCHIMB</td>
                      </tr>
                      {renderNormalLines(pieseLines, manoperaLines.length)}
                      <tr>
                          <td colSpan="5" className="text-end" style={{ fontWeight: "bold" }}>TOTAL PIESE:</td>
                          <td className="text-end" style={{ fontWeight: "bold" }}>{fmt2(totalPieseFaraTva)}</td>
                          <td></td>
                      </tr>
                      </>
                  )}
                  
                  {otherLines.length > 0 && (
                      <>
                      {(manoperaLines.length > 0 || pieseLines.length > 0) && (
                          <tr><td colSpan="7" style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}>ALTE SERVICII / PRODUSE</td></tr>
                      )}
                      {renderNormalLines(otherLines, manoperaLines.length + pieseLines.length)}
                      </>
                  )}
                </>
            );
          })()}
        </tbody>
      </table>

      {/* Footer combinat (Totaluri + Semnaturi) */}
      <div className="invoice-footer" style={{ position: "absolute", bottom: "0", left: "15mm", right: "15mm", padding: "0", fontSize: "11px" }}>
        <div>Factura circula fara semnatura si stampila conf. legii 227/2015 privind Codul fiscal, art 319 alin.29</div>
        <InvoicePrintFooter doc={doc} fmt2={fmt2} />
      </div>

      {/* Buton doar pe ecran */}
      <div className="no-print mt-4">
        <button className="btn btn-primary" onClick={() => window.print()}>
          Printeaza Factura
        </button>
      </div>
    </div>
  );
}
